// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"715b05f2","455":"57db92e4","488":"6268067a","977":"b902aff6"}[chunkId] + ".chunk.js";
};